export const publications = [
  {
    id: 3,
    title:
      "Moneyball with LLMs: Analyzing Tabular Summarization in Sports Narratives",
    authors: "Upadhyay, R., Ahuja, N., Baral, R., Garimella, A., Gupta, V.",
    venue: "ACL 2026",
    year: 2026,
    type: "Conference",
    abstract:
      "A diagnostic benchmark and analysis of long-context tabular summarization in sports narratives, focusing on how LLMs maintain state across evolving, multi-entity data.",
    links: {
      paper: "https://arxiv.org/abs/2510.18173",
    },
    tags: ["Table Summarization", "LLMs", "Sports Analytics"],
  },
  {
    id: 1,
    title: "Map&Make: Schema-Guided Text-to-Table Generation",
    authors: "Ahuja, N., Bardoliya, F., Baral, C., Gupta, V.",
    venue: "ACL 2025",
    year: 2025,
    type: "Conference",
    abstract:
      "Transform unstructured text into reliable, auditable tables with a schema-first approach that couples structural planning with rule and time-aware reasoning over long contexts.",
    links: {
      paper: "https://aclanthology.org/2025.acl-long.1460/",
    },
    tags: ["NLP", "Table Generation", "LLMs"],
  },
  {
    id: 2,
    title: "SPORTSQL: An Interactive System for Real-Time Sports Reasoning and Visualization",
    authors:
      "Martinez, S., Ahuja, N., Bardoliya, F., Roy Chowdhury, S., Bryan, C., Gupta, V.",
    venue: "IJCNLP-AACL 2025 Demo Track",
    year: 2025,
    type: "Demo",
    abstract:
      "An interactive sports reasoning and visualization system that translates natural language questions into SQL over live, dynamic sports data.",
    links: {
      paper: "https://aclanthology.org/2025.ijcnlp-demo.11/",
    },
    tags: ["NL2SQL", "QA Systems", "Sports Analytics"],
  },
  {
    id: 4,
    title: "HashSet: A Dataset for Hashtag Segmentation",
    authors:
      "Kodali, P., Bhatnagar, A., Ahuja, N., Shrivastava, M., Kumaraguru, P.",
    venue: "LREC 2022",
    year: 2022,
    type: "Conference",
    abstract:
      "A comprehensive dataset for hashtag segmentation tasks in social media text processing.",
    links: {
      paper: "https://aclanthology.org/2022.lrec-1.782/",
    },
    tags: ["NLP", "Social Media", "Dataset"],
  },
  {
    id: 5,
    title: "Estimating Code-Mix Quality via LM Embeddings",
    authors:
      "Kodali, P., Sachan, T., Goindani, A., Goel, A., Ahuja, N., Shrivastava, M., Kumaraguru, P.",
    venue: "INLG 2022 (Generation Challenges Workshop)",
    year: 2022,
    type: "Workshop",
    abstract:
      "Novel approach to evaluate the quality of code-mixed text using language model embeddings.",
    links: {
      paper: "https://aclanthology.org/2022.inlg-genchal.4/",
    },
    tags: ["Code-Mixing", "NLP", "Quality Estimation"],
  },
  {
    id: 6,
    title:
      "From Noise to Knowledge: Distill Social Media Opinions on Rumor Detection Exploiting LLMs",
    authors:
      "Sharma, S., Goyal, A., Ahuja, N., Pati, B., Sharma, R., Kumaraguru, P.",
    venue: "SSRN Working Paper, 2024",
    year: 2024,
    type: "Working Paper",
    abstract:
      "Leveraging large language models to distill knowledge from noisy social media data for improved rumor detection.",
    links: {
      paper: "https://papers.ssrn.com/sol3/papers.cfm?abstract_id=4920757",
    },
    tags: ["Social Media", "Rumor Detection", "LLMs"],
  },
];
